import React from 'react'
import { LoginContent } from './LoginContent/LoginContent'
import { SignupContent } from './SignupContent/SignupContent'
import { AUTH_CONTENT } from './consts'

type Props = {
    pathname: string,
    onSubmit?: () => void,
}

export function AuthForm(props: Props) {

    function switchContent(type) {
        switch (type) {
            case AUTH_CONTENT.LOGIN:
                return <LoginContent />

            case AUTH_CONTENT.SIGNUP:
                return <SignupContent onSubmit={() => { }} />
        }
    }

    return (
        <>
            {switchContent(props.pathname)}
        </>
    );
}

